import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell, { TruncatedLink } from "../../../components/TruncatedCell";
import emergencieService from "../../../services/emergencieService";
import { instanceToken } from "../../../utils/constant";

export default function Emergencies() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [emergencies, setEmergencies] = useState(null);

  useEffect(() => {
    fetchEmergencies(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchEmergencies = async (limit, offset) => {
    try {
      const res = await emergencieService.getAllEmergencies(
        instanceToken.token,
        limit,
        offset
      );
      parse(res.data);
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const parse = (data) => {
    setEmergencies(data.emergencies);
    setCount(data.count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const openDetail = (row) => navigate(`/emergencies/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "name_en",
      label: "Name (English)",
      render: (row) => <TruncatedCell value={row.name_en} />,
    },
    {
      id: "name_mm",
      label: "Name (Myanmar)",
      render: (row) => <TruncatedCell value={row.name_mm} myanmar />,
    },
    {
      id: "address_en",
      label: "Address (English)",
      render: (row) => <TruncatedCell value={row.address_en} />,
    },
    {
      id: "address_mm",
      label: "Address (Myanmar)",
      render: (row) => <TruncatedCell value={row.address_mm} myanmar />,
    },
    {
      id: "phone",
      label: "Phone",
      render: (row) => <TruncatedCell value={row.phone} />,
    },
    {
      id: "category",
      label: "Category",
      render: (row) => <TruncatedCell value={row.category} />,
    },
    {
      id: "phone_note",
      label: "Phone Note",
      render: (row) => <TruncatedCell value={row.phone_note} />,
    },
    {
      id: "link",
      label: "Link",
      render: (row) => (
        <TruncatedLink href={row.link} value={row.link} />
      ),
    },
  ];

  return (
    <DataListPage
      title="Emergencies"
      rows={emergencies || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      createButton={{
        label: "Create",
        onClick: () => navigate("/createEmergencies"),
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!emergencies}
    />
  );
}
